export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/calendar/Constants.js
// module id = 214
// module chunks = 0